module.exports = __webpack_public_path__ + "static/media/portAdelaide.fcc9675f.svg";